import { render } from "./MyAccount.vue?vue&type=template&id=ddfe23e6&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=ts"
export * from "./MyAccount.vue?vue&type=script&lang=ts"

import "./MyAccount.vue?vue&type=style&index=0&id=ddfe23e6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ddfe23e6"

export default script